/**
 * Central API endpoint configuration.
 * All business API endpoints should be configured here.
 */

import { configService } from './config';

const isTestMode = () => {
  return configService.getConfig().app?.testMode === true;
};

export const getUpdateCheckUrl = () => isTestMode()
  ? 'https://api.mednnect.com/update/test'
  : 'https://api.mednnect.com/update/prod';

export const getFallbackDownloadUrl = () => isTestMode()
  ? 'https://mednnect.com/download'
  : 'https://mednnect.com/download';

export const getSkillStoreUrl = () => isTestMode()
  ? 'https://api.mednnect.com/skill-store/test'
  : 'https://api.mednnect.com/skill-store/prod';

export function getApiUrl(): string {
  const wsUrl = localStorage.getItem('cowork_server_url')
    || localStorage.getItem('ws_url')
    || import.meta.env.VITE_WS_URL;
  if (wsUrl) {
    const httpUrl = wsUrl.replace(/\/ws$/, '');
    const httpProto = httpUrl.startsWith('wss') ? 'https' : 'http';
    return httpProto + '://' + httpUrl.replace(/^wss?:\/\//, '');
  }
  return import.meta.env.VITE_API_URL || window.location.origin;
}

export function getAuthToken(): string | null {
  return localStorage.getItem('auth_token') || null;
}
